import { SYS_LOCAL_LANG_KEY } from '@/lang/langConfig'
import { getStore, setStore } from '@/utils/store'

// 获取Store中的语言标识
export const getStoreSysLang = () => {
    return getStore({ name: SYS_LOCAL_LANG_KEY })
}

// 设置Store中的语言标识
export const setStoreSysLang = (lang) => {
    setStore({ name: SYS_LOCAL_LANG_KEY, content: lang, type: 'local' })
}



